import AboutUs from "pages/Company/AboutUs";

export default function AboutUsPage() {
  return <AboutUs />;
}
